var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader-container",attrs:{"aria-live":"polite","role":"status"}},[_c('div',{staticClass:"loader",attrs:{"aria-label":"Loading, please wait"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }